import {
  GetCommunitiesQuery_communities,
} from '@frontend/app/queries/types/GetCommunitiesQuery';

import { TProgram } from './program';

export interface ICommunity extends GetCommunitiesQuery_communities {
  programs?: TProgram[];
}
